console.log('mein neues javascript ist integriert');

$(document).ready(function () {
  if (window.location.href.indexOf("products") > -1) {
    if (document.querySelector('input', 'button')) {
      document.querySelectorAll('input', 'button').forEach((elem) => {
        elem.addEventListener("click", function (event) {
          var item = event.target.value;
          var clickedButtonUrl = this.baseURI;
          console.log("Variante wurde gewechselt");
          });
        });
      }
    }
  });